/**
 * Created by Akanksha on 8/14/17.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import EligibilityHelper from '../../../helpers/eligibility_helper';
import NumberFormatInput from '../../shared/number_format_input';
import SsnFormatInput from '../../shared/ssn_format_input';
import DobFormatInput from '../../shared/date_format_input';
import { TextField } from '@mui/material';

const types = PropTypes;

class EligibilityInformationDetail extends Component {
  static propTypes = {
    onChange: types.func,
    onBlur: types.func,
    customerFormValues: types.object,
    formFields: types.object,
    formOptions: types.object,
    dense: types.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      showDateOfBirthError: false,
      showAnnualIncomeError: false,
      showSocialError: false,
      dateOfBirthValue: props?.formOptions?.dateOfBirth?.initialValue || '',
      socialValue: props?.formOptions?.socialValue?.initialValue || '',
      annualIncomeValue: props?.formOptions?.annualIncomeValue?.initialValue || '',
      dateOfBirthErrorMessage: '',
      socialErrorMessage: '',
      annualIncomeErrorMessage: '',
      formOptions: this.generateFormOptions(props.formOptions),
    };
  }

  generateFormOptions = (formOptions) => {
    const defaultFormOptions = {
      dateOfBirth: {
        required: true,
        label: 'Date of Birth (MM/DD/YYYY)',
      },
      social: {
        required: true,
        label: 'SSN (9 digits, e.g. 123-45-6789)',
        digits: 9,
      },
      annualIncome: {
        required: true,
        label: 'Annual Income¹',
      },
    };
    return {
      dateOfBirth: { ...defaultFormOptions.dateOfBirth, ...formOptions?.dateOfBirth },
      social: { ...defaultFormOptions.social, ...formOptions?.social },
      annualIncome: { ...defaultFormOptions.annualIncome, ...formOptions?.annualIncome },
    };
  };

  validateDateOfBirth = (value) => {
    const errorMessage = EligibilityHelper.validateDate(value, !this.state.formOptions.dateOfBirth.required);
    this.setState({ showDateOfBirthError: errorMessage !== '', dateOfBirthErrorMessage: errorMessage });
    return errorMessage;
  };

  handleDateOfBirthChange = (e) => {
    if (this.state.showDateOfBirthError) {
      this.validateDateOfBirth(e.target.value);
    }
    this.setState({ dateOfBirthValue: e.target.value });
    this.props.onChange(e, e.target.id, e.target.value);
  };

  handleDateOfBirthBlur = (e) => {
    e.target.setCustomValidity(this.validateDateOfBirth(e.target.value));
    /* eslint-disable no-unused-expressions */
    if (typeof this.props?.onBlur === 'function') {
      this.props?.onBlur(e, e.target.id, e.target.value);
    }
    /* eslint-enable no-unused-expressions */
  };

  validateSocial = (value) => {
    const socialOptions = this.state.formOptions.social;
    const errorMessage = EligibilityHelper.validateSSN(value, socialOptions.digits, !socialOptions.required);
    this.setState({ showSocialError: errorMessage !== '', socialErrorMessage: errorMessage });
    return errorMessage;
  };

  handleSocialChange = (e) => {
    const { maskedValue: socialValue, unmaskedValue } = e;
    if (this.state.showSocialError) {
      this.validateSocial(unmaskedValue);
    }
    this.setState({ socialValue });
    this.props.onChange(e, e.target.id, unmaskedValue);
  };

  handleSocialBlur = (e) => {
    e.target.setCustomValidity(this.validateSocial(e.unmaskedValue));
    /* eslint-disable no-unused-expressions */
    if (typeof this.props?.onBlur === 'function') {
      this.props?.onBlur(e, e.target.id, e.unmaskedValue);
    }
    /* eslint-enable no-unused-expressions */
  };

  validateAnnualIncome = (value) => {
    const errorMessage = EligibilityHelper.validateIncome(value, !this.state.formOptions.annualIncome.required);
    this.setState({ showAnnualIncomeError: errorMessage !== '', annualIncomeErrorMessage: errorMessage });
    return errorMessage;
  };

  handleAnnualIncomeChange = (e) => {
    const { unmaskedValue } = e;
    if (this.state.showAnnualIncomeError) {
      this.validateAnnualIncome(unmaskedValue);
    }
    this.setState({ annualIncomeValue: unmaskedValue });
    this.props.onChange(e, e.target.id, unmaskedValue);
  };

  handleAnnualIncomeBlur = (e) => {
    e.target.setCustomValidity(this.validateAnnualIncome(e.unmaskedValue));
    /* eslint-disable no-unused-expressions */
    if (typeof this.props?.onBlur === 'function') {
      this.props?.onBlur(e, e.target.id, e.unmaskedValue);
    }
    /* eslint-enable no-unused-expressions */
  };

  DateOfBirthNumberFormat = (props) => DobFormatInput({ ...props, onChange: this.handleDateOfBirthChange });
  SocialNumberFormat = (props) =>
    SsnFormatInput({ ...props, digits: this.state.formOptions.social.digits, onChange: this.handleSocialChange });
  AnnualIncomeNumberFormat = (props) => NumberFormatInput({ ...props, onChange: this.handleAnnualIncomeChange }, 0);

  render() {
    const { formFields, dense } = this.props;
    const { formOptions } = this.state;

    return (
      <div className="eligibility-information-detail">
        <div className="flex-row">
          <TextField
            className="text-field"
            name={formFields.dateOfBirth}
            required={formOptions.dateOfBirth.required}
            fullWidth={true}
            size={dense ? 'small' : 'medium'}
            margin={dense ? 'dense' : 'normal'}
            variant="outlined"
            label={formOptions.dateOfBirth.label}
            id={formFields.dateOfBirth}
            value={this.state.dateOfBirthValue}
            onBlur={this.handleDateOfBirthBlur}
            InputLabelProps={{ required: false, shrink: !!this.state.dateOfBirthValue }}
            InputProps={{
              inputComponent: this.DateOfBirthNumberFormat,
            }}
            error={this.state.showDateOfBirthError}
            helperText={
              this.state.showDateOfBirthError && this.state.dateOfBirthErrorMessage
                ? this.state.dateOfBirthErrorMessage
                : ''
            }
          />
          <TextField
            className="text-field"
            name={formFields.social}
            required={formOptions.social.required}
            fullWidth={true}
            size={dense ? 'small' : 'medium'}
            margin={dense ? 'dense' : 'normal'}
            variant="outlined"
            label={formOptions.social.label}
            id={formFields.social}
            value={this.state.socialValue}
            onBlur={this.handleSocialBlur}
            InputLabelProps={{ required: false, shrink: !!this.state.socialValue }}
            InputProps={{
              inputComponent: this.SocialNumberFormat,
            }}
            error={this.state.showSocialError}
            helperText={
              this.state.showSocialError && this.state.socialErrorMessage ? this.state.socialErrorMessage : ''
            }
          />
        </div>

        <div className="flex-row">
          <TextField
            className="text-field income-input"
            name={formFields.annualIncome}
            required={formOptions.annualIncome.required}
            fullWidth={true}
            size={dense ? 'small' : 'medium'}
            margin={dense ? 'dense' : 'normal'}
            variant="outlined"
            label={formOptions.annualIncome.label}
            id={formFields.annualIncome}
            value={this.state.annualIncomeValue}
            onBlur={this.handleAnnualIncomeBlur}
            InputLabelProps={{ required: false, shrink: !!this.state.annualIncomeValue }}
            InputProps={{
              inputComponent: this.AnnualIncomeNumberFormat,
            }}
            error={this.state.showAnnualIncomeError}
            helperText={
              this.state.showAnnualIncomeError && this.state.annualIncomeErrorMessage
                ? this.state.annualIncomeErrorMessage
                : ''
            }
          />
          <div className="spacer" />
        </div>
        <small className="fineprint fineprint-nextline">
          <b>
            ¹ Alimony, child support or separate maintenance income need not be included unless relied upon as a basis
            for repayment of this obligation.
          </b>
        </small>
      </div>
    );
  }
}

export default EligibilityInformationDetail;
